import "../styles.css";
import { AppRoot as NativeAppRoot } from "./AppRoot.native";
import React from "react";

export function AppRoot() {
  return <NativeAppRoot />;
}
